<script setup lang="ts">
interface Props {
  title: string;
  highlightText?: string;
  description?: string;
  backgroundGlows?: boolean;
  gradientColors?: {
    top?: string;
    bottom?: string;
  };
}

withDefaults(defineProps<Props>(), {
  highlightText: '',
  description: '',
  backgroundGlows: true,
  gradientColors: () => ({
    top: 'bg-rad-red/20',
    bottom: 'bg-blue-500/20'
  })
});
</script>

<template>
  <section class="relative pt-32 pb-20 px-4 overflow-hidden" :class="[
    backgroundGlows ? 'bg-white dark:bg-slate-950' : 'bg-transparent'
  ]">
    <!-- Background Glows -->
    <div v-if="backgroundGlows" class="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-6xl h-[500px] blur-[120px] rounded-full -z-10" :class="gradientColors.top"></div>
    <div v-if="backgroundGlows" class="absolute bottom-0 right-0 w-[400px] h-[400px] blur-[100px] rounded-full -z-10" :class="gradientColors.bottom"></div>

    <div class="max-w-4xl mx-auto text-center">
      <h1 class="text-5xl sm:text-6xl font-bold mb-6 tracking-tight text-slate-900 dark:text-rad-white leading-[1.1]">
        {{ title }}
        <span v-if="highlightText" class="rad-text-gradient">{{ highlightText }}</span>
      </h1>
      <p v-if="description" class="text-xl text-slate-700 dark:text-slate-400 max-w-3xl mx-auto leading-relaxed">
        {{ description }}
      </p>
    </div>
  </section>
</template>